import { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { motion } from "framer-motion";

gsap.registerPlugin(ScrollTrigger);

const TestimonialsSection = () => {
  const sectionRef = useRef(null);
  const testimonialsRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    const testimonials =
      testimonialsRef.current?.querySelectorAll(".testimonial-card");

    if (section && testimonials) {
      testimonials.forEach((testimonial, index) => {
        gsap.fromTo(
          testimonial,
          { x: index % 2 === 0 ? -100 : 100, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            duration: 1,
            scrollTrigger: {
              trigger: testimonial,
              start: "top bottom-=100",
              end: "bottom center",
              scrub: 1,
              toggleActions: "play none none reverse",
            },
          }
        );
      });
    }

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, [sectionRef, testimonialsRef]);

  const testimonials = [
    {
      name: "Khaled Salleh",
      role: "Computer Science Student",
      image: "khaled.jpg",
      quote:
        "The GUC Internship Portal made it incredibly easy to find and apply to tech internships. I secured a position at Google thanks to the platform's smart matching system!",
    },
    {
      name: "Omar Amin",
      role: "Technology Partner",
      image: "Omar.jpg",
      quote:
        "We've found exceptional talent through the GUC Internship Portal. The assessment tools and analytics help us identify the best candidates efficiently.",
    },
    {
      name: "Youssef ELfeky",
      role: "Business Administration Student",
      image: "Youssef.png",
      quote:
        "From application to evaluation, the entire process was streamlined and professional. The real-time updates kept me informed every step of the way.",
    },
  ];

  return (
    <section
      id="testimonials"
      ref={sectionRef}
      className="min-h-screen bg-gray-900 py-20 px-4"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="container mx-auto text-center mb-16"
      >
        <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">
          Success Stories
        </h2>
        <p className="text-xl text-gray-300 max-w-3xl mx-auto">
          Hear from students and companies who have transformed their internship
          experience through our platform.
        </p>
      </motion.div>

      <div
        ref={testimonialsRef}
        className="container mx-auto space-y-10 max-w-4xl"
      >
        {testimonials.map((testimonial, index) => (
          <motion.div
            key={index}
            className="testimonial-card bg-gray-800 bg-opacity-50 backdrop-blur-lg rounded-2xl p-6 border border-gray-700"
            
          >
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-purple-500 flex-shrink-0">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1">
                <p className="text-gray-300 text-lg italic mb-4">
                  "{testimonial.quote}"
                </p>
                <div>
                  <h4 className="text-white font-bold text-xl">
                    {testimonial.name}
                  </h4>
                  <p className="text-purple-400">{testimonial.role}</p>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
